import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";

import { getOutlets, deleteOutlet } from "../services/outletService";
import "./OutletsList.css";

const OutletsLayerList = () => {
  const [outlets, setOutlets] = useState([]);
  const [filteredOutlets, setFilteredOutlets] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const navigate = useNavigate();

  useEffect(() => {
    fetchOutlets();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [search, statusFilter, outlets]);

  const fetchOutlets = async () => {
    try {
      const res = await getOutlets();
      const data = Array.isArray(res.data) ? res.data : [];
      setOutlets(data);
      setFilteredOutlets(data);
    } catch {
      toast.error("Failed to load outlets!");
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let data = [...outlets];

    // STATUS FILTER
    if (statusFilter !== "all") {
      data = data.filter(
        (o) => o.outlet_status?.toLowerCase() === statusFilter
      );
    }

    // SEARCH FILTER
    if (search.trim()) {
      const q = search.toLowerCase();
      data = data.filter(
        (o) =>
          o.outlet_name?.toLowerCase().includes(q) ||
          o.outlet_code?.toLowerCase().includes(q) ||
          o.outlet_phone?.toLowerCase().includes(q) ||
          o.outlet_email?.toLowerCase().includes(q)
      );
    }

    setFilteredOutlets(data);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this outlet?")) return;
    try {
      const res = await deleteOutlet(id);
      if (res.status === "success") {
        toast.success("Outlet deleted");
        fetchOutlets();
      } else toast.error(res.message || "Delete failed");
    } catch {
      toast.error("Delete failed");
    }
  };

  const handleEdit = (id) => navigate(`/add-outlet/${id}`);

  if (loading) return <div className="ol-loading">Loading outlets…</div>;

  return (
    <div className="ol-page">
      {/* HEADER */}
      <div className="ol-header">
        <div className="ol-header-left">
          <h3>Outlets List</h3>
        </div>
        <Link to="/add-outlet" className="ol-add-btn">
          <Icon icon="ri:add-line" /> Add Outlet
        </Link>
      </div>

      {/* SEARCH + FILTER */}
      <div className="ol-filters">
        <div className="ol-search">
          <Icon icon="ri:search-line" />
          <input
            type="text"
            placeholder="Search outlet..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <select
          className="ol-select"
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="all">All Status</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </select>
      </div>

      {/* GRID */}
      <div className="ol-grid">
        {filteredOutlets.length === 0 ? (
          <div className="ol-empty">No outlets found.</div>
        ) : (
          filteredOutlets.map((item) => (
            <div key={item.id} className="ol-card">
              <div className="ol-card-top">
                <div className="ol-icon">
                  <Icon icon="ri:store-2-line" />
                </div>
                <span
                  className={`ol-status ${
                    item.outlet_status?.toLowerCase() === "active"
                      ? "active"
                      : "inactive"
                  }`}
                >
                  {item.outlet_status}
                </span>
              </div>

              <h4 className="ol-title">{item.outlet_name}</h4>

              <div className="ol-meta">
                <span className="ol-chip">{item.outlet_code}</span>
              </div>

              <div className="ol-details">
                <p><Icon icon="ri:map-pin-2-line" /> {item.outlet_address}</p>
                <p><Icon icon="ri:phone-line" /> {item.outlet_phone}</p>
                <p>
                  <Icon icon="ri:mail-line" />{" "}
                  {item.outlet_email || "No Email"}
                </p>
              </div>

              <div className="ol-actions">
                <button className="ol-btn edit" onClick={() => handleEdit(item.id)}>
                  <Icon icon="ri:edit-line" /> Edit
                </button>
                <button className="ol-btn delete" onClick={() => handleDelete(item.id)}>
                  <Icon icon="ri:delete-bin-line" /> Delete
                </button>
              </div>

              <button className="ol-enter">
                Enter <Icon icon="ri:arrow-right-line" />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default OutletsLayerList;
